<template>
  <div>
    <!-- v-if="project!=null" class="project-container" -->
    <div class="row animated fadeIn">
      <Loading :active="true" :is-full-page="true"></Loading>
    </div>
  </div>
</template>

<script>
// import store from "../../store";
// import { mapGetters } from "vuex";
// import { Notification } from "element-ui";

// Import component
import Loading from "vue-loading-overlay";

// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "ProjectViewSwitcher",
  components: {
    Loading
  },
  data() {
    return {
      modality: 0,
      projectId: "",
      defined: false
    };
  },
  mounted: function() {
    var that = this;
    that.$nextTick(function() {
      //alert('switching');
      if (that.defined) {
        this.$store.dispatch("resetSubViews");
        this.$router.push({
          name: "ViewProject",
          params: {
            modality: that.modality,
            projectId: that.projectId
          }
        });
      }
    });
  },
  beforeRouteEnter: function(to, from, next) {
    //alert('before');
    next(vm => {
      vm.modality = to.params.modality;
      vm.projectId = to.params.projectId;
      vm.defined = true;
    });
  }
};
</script>

<style></style>
